/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React, {useState} from "react";

import WhyJoinWealthy from "./WhyJoinWealthy";


const WhyJoinWealthyContainer = () => {
  const [delay, setDelay] = useState(Infinity);

  const visibilitySensorHandler = (isVisible) => {
    if (isVisible && !!delay) {
      setDelay(0);
    }
  };

  return (
    <WhyJoinWealthy
      delay={delay}
      visibilitySensorHandler={visibilitySensorHandler}
    />
  );
};

export default WhyJoinWealthyContainer;
